var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 87 19.986 c -1.657 0 -3 1.343 -3 3 v 44.027 c 0 0.999 -0.295 1.924 -0.781 2.72 L 63.005 49.021 c -1.111 -1.137 -2.916 -1.213 -4.116 -0.168 L 45.173 60.779 l -1.383 -1.422 c -1.155 -1.188 -3.054 -1.215 -4.242 -0.059 c -1.188 1.154 -1.214 3.054 -0.06 4.242 l 3.361 3.456 c 1.11 1.142 2.919 1.218 4.12 0.172 l 13.72 -11.93 l 16.619 17.029 H 25.623 c -1.657 0 -3 1.343 -3 3 s 1.343 3 3 3 h 53.122 c 2.188 0 4.226 -0.638 5.955 -1.722 c 0.047 -0.028 0.094 -0.054 0.14 -0.085 C 87.94 74.454 90 70.973 90 67.014 V 22.986 C 90 21.33 88.657 19.986 87 19.986 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(173,173,173)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89.233 5.323 c -1.106 -1.232 -3.004 -1.336 -4.236 -0.23 l -7.401 6.638 H 11.255 C 5.049 11.731 0 16.78 0 22.986 v 44.027 c 0 4.027 2.133 7.557 5.323 9.546 l -4.326 3.88 c -1.233 1.106 -1.336 3.003 -0.23 4.236 c 0.593 0.661 1.412 0.997 2.234 0.997 c 0.713 0 1.429 -0.253 2.002 -0.767 l 84 -75.348 C 90.236 8.453 90.34 6.556 89.233 5.323 z M 11.255 17.731 h 59.652 L 34.802 50.117 l -8.927 -9.179 c -1.124 -1.155 -2.958 -1.217 -4.155 -0.14 L 6 54.923 V 22.986 C 6 20.088 8.357 17.731 11.255 17.731 z M 6 67.014 v -4.025 l 17.584 -15.8 l 6.748 6.938 L 10.223 72.164 C 7.818 71.683 6 69.558 6 67.014 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(173,173,173)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.167,
    cy: 29.037,
    r: 6.047,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(173,173,173)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/NoImage.92e95f833b398377d95ea72d7cb88a7d.svg";
export { ForwardRef as ReactComponent };